import styled, { css } from "styled-components";

import Row from "components/Form/Row";

export const Container = styled.div`
  width: 418px;
  margin-bottom: 40px;
`;

export const ControlRow = styled(Row)`
  margin-bottom: 30px;
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

export const ButtonContainer = styled.div`
  display: flex;

  width: 100px;

  &:not(:last-child) {
    margin-right: 30px;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;

  ${({ width }: { width?: string }) =>
    css`
      width: ${width ?? "100%"};
    `}

  &:not(:last-child) {
    margin-right: 32px;
  }
`;
